<template>
  <div class="green-app">
    <div class="main">
      <!-- 左边导航 -->
      <!-- <div v-if="false" class="nav-bar">
        <NavBarList @selectOption='selectOption' />
      </div> -->

      <!-- 右边展示内容 -->
      <div class="main-view">
        <!-- 内容顶部类型导航 -->
        <div class="type-nav">
          <TypeNavBar @selectRtype='selectRtype' />
          <el-tag v-if="selectName!=''" :disable-transitions="false" @close="handleClose" :key="selectName"
            :closable='true' type="success">
            {{selectName}}
          </el-tag>
          <div class="search-name">
            <el-input @change='searchChange' maxlength="30" placeholder="可搜索应用名称" v-model="searchName" clearable>
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </div>
        </div>

        <!-- 内容展示 -->
        <div class="content-list">
          <ResourceList :loading='loading' :greenAppData='greenAppData' />

          <!-- 页码 -->
          <div class="page-num">
            <PageNum :pageTotal='pageTotal' :currentPage1.sync='currentPage' />
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
//API--------------------------------------------
import { getGreenApp } from "@/network/resourceRequest/api";
//工具--------------------------------------------
import utils from "@/util/index";

//左边导航
// import NavBarList from "@/views/resourceCenter/components/amCloudResource/components/NavBarList";
//顶部导航
import TypeNavBar from "@/views/appCenter/components/greenApp/components/TypeNavBar";
//内容导航--------------------------------------------
import ResourceList from "@/views/appCenter/components/greenApp/components/ResourceList";
//页码导航--------------------------------------------
import PageNum from "@/components/common/PageNum";

export default {
  name: "CloudResource",
  components: {
    // NavBarList,
    TypeNavBar,
    ResourceList,
    PageNum
  },
  data() {
    return {
      //筛选的条件
      fd: {},

      //当前页码--------------------------------------------
      currentPage: 1,
      //页码总数量
      pageTotal: 0,

      //展示内容
      greenAppData: {},

      //加载状态--------------------------------------------
      loading: true,

      //搜索内容--------------------------------------------
      searchName: "",
      //选择名字--------------------------------------------
      selectName: ""
    };
  },

  watch: {
    //页码筛选
    currentPage(newVal, oldVal) {
      this.fd.pageNum = newVal;
      this.getSelectResource(this.fd, "pageNum");
    }
  },

  methods: {
    //关闭搜索标签--------------------------------------------
    handleClose() {
      this.selectName = "";
      this.fd.name && delete this.fd.name;
      this.getSelectResource(this.fd);
    },

    //搜索--------------------------------------------
    searchChange(value) {
      if (value != "") {
        this.fd.name = value;
        this.selectName = value;
        this.searchName = "";
        this.getSelectResource(this.fd);
      }
    },

    //侧边筛选数据  删除
    selectOption(option) {
      for (const key in option) {
        if (option.hasOwnProperty(key)) {
          const element = option[key];
          this.$set(this.fd, key, element);
        }
      }
      this.getSelectResource(this.fd);
    },

    //type筛选
    selectRtype(option) {
      this.$set(this.fd, "category", option);
      //初始化不进来
      this.getSelectResource(this.fd);
    },

    //根据条件获取数据
    getSelectResource(fd, type) {
      if (type != "pageNum") {
        this.fd.pageNum = 1;
        this.currentPage = 1;
      }
      //进行任何非页码筛选均改回第一页
      this.fd.pageSize = 10;
      getGreenApp(fd).then(res => {
        if (res.data.success) {
          this.greenAppData = res.data.data ? res.data.data : {};
          this.pageTotal = res.data.data ? Number(res.data.data.total) : 0;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.green-app {
  padding-top: 5px;

  .main {
    width: 1200px;
    min-height: 800px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    // 左边导航
    .nav-bar {
      box-shadow: 0 0 5px 1px #ccc;
      border-radius: 5px;
      width: 235px;
      min-height: 500px;
      background-color: #fff;
      padding: 0 20px;
    }

    //内容
    .main-view {
      box-shadow: 0 0 5px 1px #ccc;
      border-radius: 5px;
      overflow: hidden;
      width: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .type-nav {
        position: relative;

        /deep/.el-tag {
          position: absolute;
          top: 50%;
          transform: translateY(-16px);
          right: 265px;
        }

        .search-name {
          max-width: 250px;
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-20px);
          display: flex;
          align-items: center;

          /deep/.el-input__inner:focus {
            border-color: #dcdfe6;
          }
        }
      }

      .content-list {
        width: 100%;
        height: 100%;

        .page-num {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 20px 0;
        }
      }
    }
  }
}
</style>